import { COLORS } from '../colors'

export const MuiDialog = {
  paper: {
    border: '1px solid ' + COLORS.blue
  }
}
